export default __webpack_public_path__ + "assets/italic.6311ac29.svg";